import Http from "./../http";

export default {
  // 奶粉星球文章列表接口
  getListByTag(params, callback) {
    Http.post("/milkPowderArticle/getListByTag", {}, params, res => {
      callback(res);
    });
  },
  // 奶粉星球标签列表接口
  getTagAll(params, callback) {
    Http.get("/milkPowderArticle/getTagAll", params, res => {
      callback(res);
    });
  },
  // 每日辟谣回答问题
  getanswer(urlParams, params, callback) {
    Http.post("/milk/refuteRumors/answer", urlParams, params, res => {
      console.log(res, "eeee");
      callback(res);
    });
  },
  // 每日辟谣查询问题
  getquestion(params, callback) {
    Http.get("/milk/refuteRumors/query", params, res => {
      callback(res);
    });
  },
  // 每日辟谣查询历史列表
  getHistorylist(urlParams, params, callback) {
    Http.post("/milk/refuteRumors/history", urlParams, params, res => {
      console.log(res, "eeee");
      callback(res);
    });
  },
  //获取热搜词
  getExpertSearch(params, callback) {
    Http.get("/milkPowderSearch/searchHot", params, res => {
      callback(res);
    });
  }
};
